import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/checked.png'
import _imports_1 from '@/assets/icon/notchecked.png'


const _withScopeId = n => (_pushScopeId("data-v-605b8728"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dialog-contents"
}
const _hoisted_2 = { class: "dialog" }
const _hoisted_3 = { class: "dialog-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title-text" }, "添加要一起退货的商品", -1))
const _hoisted_5 = { class: "dialog-info" }
const _hoisted_6 = { class: "dialog-info-v" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "dialog-edit" }
const _hoisted_10 = {
  key: 0,
  class: "dialog-info-v-img",
  src: _imports_1
}
const _hoisted_11 = {
  key: 1,
  class: "dialog-info-v-img",
  src: _imports_0
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dialog-info-v-text" }, "全选", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_goods_more_select = _resolveComponent("goods-more-select")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("i", {
              class: "icon iconfont icon-shanchu",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleConfirm && _ctx.handleConfirm(...args)))
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodsList, (goods, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (goods.isSelect)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "dialog-info-v-img",
                      onClick: ($event: any) => (_ctx.selectGoods(index)),
                      src: _imports_0
                    }, null, 8, _hoisted_7))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "dialog-info-v-img",
                      onClick: ($event: any) => (_ctx.selectGoods(index)),
                      src: _imports_1
                    }, null, 8, _hoisted_8)),
                _createVNode(_component_goods_more_select, { goods: goods }, null, 8, ["goods"])
              ]))
            }), 256))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "dialog-edit-all",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectAllGoods()))
            }, [
              (!_ctx.isAll)
                ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                : (_openBlock(), _createElementBlock("img", _hoisted_11)),
              _hoisted_12
            ]),
            _createElementVNode("div", {
              class: "dialog-edit-cancel",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleConfirm && _ctx.handleConfirm(...args)))
            }, "取消"),
            _createElementVNode("div", {
              class: "dialog-edit-define",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args)))
            }, "提交选择")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}